import { animationTransition } from '@shared/utils/animationTransition';
import { Box, css, styled } from '@withjoy/joykit';

export const SHADOW_WIDTH = '-1px';
export const BORDER_RADIUS = 1000;
export const LEFT_RIGHT = '3px';
export const WIDTH_HEIGHT = 'calc(100% - 6px)';
export const BOX_SHADOW = '0 1px 3px rgba(0, 0, 0, 0.12)';
export const ACTIVE_BORDER_COLOR = '#333333';
export const BORDER_COLOR_DEFAULT = '#767676';

const StyledAnimation = css`
  transition: ${animationTransition('background')};
  background: linear-gradient(270deg, #0ca599, #4951ef, #ba2bc4, #0ca599);
  background-size: 400% 400%;
  animation: moveBlurGradient 5s ease-in-out infinite;
  @keyframes moveBlurGradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export const StyledBoxShadow = styled(Box)<{ $showGradientShadow: boolean; $borderRadius: number }>`
  &::before {
    ${({ $showGradientShadow, $borderRadius }) =>
      $showGradientShadow &&
      css`
        content: '';
        position: absolute;
        top: ${SHADOW_WIDTH};
        left: ${SHADOW_WIDTH};
        right: ${SHADOW_WIDTH};
        bottom: ${SHADOW_WIDTH};
        filter: blur(8px);
        opacity: 0.2;
        border-radius: ${$borderRadius}px;
        z-index: 0;
        pointer-events: none;
        ${StyledAnimation}
      `}
  }
`;

export const StyledBorder = styled(Box)<{ $showGradientBorder: boolean; $showTransparentBackground?: boolean; $borderWidth: number }>`
  ${({ $showGradientBorder }) => $showGradientBorder && StyledAnimation}
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: ${({ $showTransparentBackground }) => ($showTransparentBackground ? 'source-out' : 'initial')};
  mask-composite: ${({ $showTransparentBackground }) => ($showTransparentBackground ? 'exclude' : 'initial')};
  padding: ${({ $borderWidth }) => $borderWidth}px;
`;

export const StyledArrow = styled(Box)`
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translate(-50%, 0);
`;
